import parse, { domToReact, Element, DOMNode } from 'html-react-parser';

import styles from './ParsedTextBlock.module.scss';
import type { ContentBlockProps } from './types';
import { parseText } from '../../parseText';

const ParsedTextBlock: React.FC<ContentBlockProps> = ({ block }) => {
  const { text } = block;
  return <div className={styles.blockText}>{text && parseText(text)}</div>;
};
export default ParsedTextBlock;
